const companyRouters = {
  path: "/company",
  component: () => import("@/views/layout"),
  name: "company",
  meta: { public: true, theme: "black", titleSuffix: "_管理后台" },
  children: [
    {
      path: "manage",
      component: () => import("@/views/Company/Manage/Layout"),
      name: "company-manage",
      redirect: "manage/info",
      children: [
        {
          path: "home",
          component: () => import("@/views/Company/Manage/HomePage"),
          name: "company-home-page"
        },
        {
          path: "info",
          component: () => import("@/views/Company/Manage/Info"),
          name: "company-manage-info"
        },
        {
          path: "open-app",
          component: () => import("@/views/Company/Manage/DevelopPlatform/OpenApp"),
          name: "company-open-app"
        },
        {
          path: "log",
          component: () => import("@/views/Company/Manage/DataSecurity"),
          name: "company-manage-log"
        },
        {
          path: "company-system-joint",
          component: () => import("@/views/Company/Manage/SystemJoint"),
          name: "company-system-joint"
        },
        {
          path: "company-joint-setting",
          component: () => import("@/views/Company/Manage/SystemJoint/JointSetting"),
          name: "company-joint-setting"
        },
        {
          path: "operation",
          component: () => import("@/views/Company/Manage/Operation"),
          name: "company-manage-operation"
        },
        {
          path: "calendar",
          component: () => import("@/views/Company/Manage/Info/Calendar"),
          name: "company-manage-calendar"
        },
        {
          path: "company-role",
          component: () => import("@/views/Company/Manage/User/CompanyRole"),
          name: "company-role"
        },
        {
          path: "company-user",
          component: () => import("@/views/Company/Manage/User/CompanyUser"),
          name: "company-user"
        },
        {
          path: "company-review",
          component: () => import("@/views/Company/Manage/User/CompanyReview"),
          name: "company-review"
        },
        {
          path: "company-invite-setting",
          component: () => import("@/views/Company/Manage/User/InviteSetting"),
          name: "company-invite-setting"
        },
        {
          path: "app",
          component: () => import("@/views/Company/Manage/App"),
          name: "company-manage-app"
        },
        {
          path: "app-group",
          component: () => import("@/views/Company/Manage/App/AppGroup"),
          name: "company-app-group"
        },
        {
          path: "app-template",
          component: () => import("@/views/Company/Manage/App/Template"),
          name: "company-app-template"
        },
        {
          path: "project",
          component: () => import("@/views/Company/Manage/Project/ProjectList"),
          name: "company-manage-project"
        },
        {
          path: "project-group",
          component: () => import("@/views/Company/Manage/Project/ProjectGroup"),
          name: "company-project-group"
        },
        {
          path: "project/task-template",
          component: () => import("@/views/Company/Manage/Project/TaskTemplate"),
          name: "company-manage-task-template"
        },
        {
          path: "project/project-template",
          component: () => import("@/views/Company/Manage/Project/ProjectTemplate"),
          name: "company-manage-project-template"
        },
        {
          path: "project/company-connect-list",
          component: () => import("@/views/Company/Manage/Connect/ConnectCompany"),
          name: "company-manage-connect-list"
        },
        {
          path: "project/company-connect-type",
          component: () => import("@/views/Company/Manage/Connect/ConnectType"),
          name: "company-manage-connect-type"
        }
      ]
    }
  ]
}

export default companyRouters
